/**
 * 国际化配置文件
 * SC:中文
 * TC:繁体
 */
 export default {


   sysManagement: { SC:"系统管理", TC: "系統管理", EN: "System" }
   ,update: { SC:"修改", TC: "修改", EN: "Edit" }
   ,delete: { SC:"删除", TC: "刪除", EN: "Delete" }
   ,audit: { SC:"日志", TC: "日誌", EN: "Log" }
   ,selectiveData: { SC:"请选择一条数据", TC: "請選擇一條數據", EN: "Please select a reord." }
   ,deleteData: { SC:"数据删除中...", TC: "數據删除中...", EN: "Data is processing..." }
   ,deleteSuccess: { SC:"删除成功", TC: "刪除成功", EN: "Deleted successfully." }
   ,beQuerying: { SC:"查询中...", TC: "査詢中...", EN: "Searching..." }
   ,noneDate: { SC:"找不到符合条件记录.", TC: "找不到符合條件記錄.", EN: "No record is founed." }
   ,saveSuccess: { SC:"保存成功", TC: "保存成功", EN: "Saved successfully." }
   ,controls: { SC:"操作", TC: "操作", EN: "Operation" }
   ,list: { SC:"列表", TC: "列表", EN: "List" }
   ,search: { SC:"查询", TC: "査詢", EN: "Search" }
   ,reset: { SC:"重置", TC: "重置", EN: "Reset" }
   ,add: { SC:"新增", TC: "新增", EN: "Add" }
   ,save: { SC:"保存", TC: "保存", EN: "Save" }
   ,cancel: { SC:"取消", TC: "取消", EN: "Cancel" }
   ,dataBeSaving: { SC:"数据保存中...", TC: "數據保存中...", EN: "Data is processing..." }
   ,download: { SC:"下载", TC: "下載", EN: "Download" }
   ,downloadExcel: { SC:"导出Excel表格", TC: "匯出Excel表格" , EN: "Download Report" }

   ,downloadFunc: { SC:"模块.xlsx", TC: "模塊.xlsx", EN: "Function.xlsx" }
   ,settingsImg: { SC:"设置图片", TC: "設定圖片", EN: "Upload Photo" }
   ,awaitImg: { SC:"请等待图片上传完成", TC: "請等待圖片上傳完成", EN: "Please wait for uploading the photo." }
   ,loseImg: { SC:"请先处理测试上传失败的图片", TC: "請先處理測試上傳失敗的圖片", EN: "Please handle the failed images first." }
   ,dispSeq: { SC:"序号", TC: "序號", EN: "Seq" }
   ,funcName: { SC:"模块名称", TC: "模塊名稱", EN: "Function Name" }
   ,funcNameSC: { SC:"模块名称(中文简体)", TC: "模塊名稱(中文簡體)", EN: "Function Name(Simplified Chinese)" }
   ,funcNameTC: { SC:"模块名称(中文繁体)", TC: "模塊名稱(中文繁體)", EN: "Function Name(Traditional Chinese)" }
   ,funcNameEN: { SC:"模块名称(英文)", TC: "模塊名稱(英文)", EN: "Function Name(English)" }
   ,funcNameIsNoNullSC: { SC:"模块名称(中文简体)不能为空", TC: "模塊名稱(中文簡體)不能為空", EN: "Function Name(Simplified Chinese) is required." }
   ,funcNameIsNoNullTC: { SC:"模块名称(中文繁体)不能为空", TC: "模塊名稱(中文繁體)不能為空", EN: "Function Name(Traditional Chinese) is required." }
   ,funcNameIsNoNullEN: { SC:"模块名称(英文)不能为空", TC: "模塊名稱(英文)不能為空", EN: "Function Name(English) is required." }
   ,funcCode: { SC:"模块编号", TC: "模塊編號", EN: "Function Code" }
   ,funcCodeIsNoNull: { SC:"模块编号不能为空", TC: "模塊編號不能為空", EN: "Function Code is required." }
   ,type: { SC:"模块类型", TC: "模塊類型", EN: "Function Type" }
   ,typeIsNoNull: { SC:"模块类型不能为空", TC: "模塊類型不能為空", EN: "Function Type is required." }
   ,funcUrl: { SC:"路由地址", TC: "路由地址", EN: "Router Url" }
   ,func: { SC:"模块", TC: "模塊", EN: "Function" }
   ,oneFunc: { SC:"一级模块", TC: "一級模塊", EN: "Menu" }
   ,oneFuncIsNoNull: { SC:"一级模块不能为空", TC: "一級模塊不能為空", EN: "Menu is required." }
   ,twoFunc: { SC:"二级模块", TC: "二級模塊", EN: "Function" }
   ,twoFuncIsNoNull: { SC:"二级模块不能为空", TC: "二級模塊不能為空", EN: "Function is required." }
   ,img: { SC:"图片", TC: "圖片", EN: "Photo" }
   ,maxImg: { SC:"放大图", TC: "放大圖", EN: "Enlarged View" }
   ,sysManage: { SC:"系统管理", TC: "系統管理" , EN: "System" }
   ,deleteImg: { SC:"您确定要删除该图片吗？", TC: "您確定要刪除該圖片嗎？", EN: "Confirm delete Photo?" }
   ,ok: { SC:"确定", TC: "確定", EN: "Confirm" }
}